/*
 * @Author: your name
 * @Date: 2021-04-01 10:11:24
 * @LastEditTime: 2021-04-27 12:03:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \exclusive-cloud-admin\main\src\shared\index.ts
 */
import store from "./store";

const authority = require("@/../../common/src/assets/authority/authority");


class Shared {
    /**
     * 获取存储数据
     * @param name
     */
    public getStore(name: string) {
        let state: any = store.getState();
        return state[name] || "";
    }

    /**
     * 设置存储数据
     * @param name
     * @param value
     */
    public setStore(name: string, value: any) {
        let state: any = store.getState();
        state['type'] = state['type'] || '';
        state[name] = value;
        store.dispatch(state)
    }

    public $router: any = '';

    public authority = authority;
}


const shared = new Shared();
export default shared;
